import {
  useState,
  useEffect,
} from 'react'
import { useSelector } from "react-redux"

import {
  Box,
} from '@chakra-ui/react'

import 'leaflet/dist/leaflet.css'
import {
  AttributionControl,
  MapContainer,
  Polyline,
  TileLayer,
  ZoomControl,
  useMap,
} from 'react-leaflet'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer'

import {
  StationMarker,
} from './MapMarkers'
import MapRecenterOnPoint from './MapRecenter'
import {
  getTileLayerForUser,
  getZoomForCountryCode
} from '../../utilities/mappingHelper'
import MapImageDownloadButton from './MapImageDownloadButton'
import MapWatermark from './MapWatermark'
import MapInitializer from './MapInitializer'
import { MapProvider } from '../../contexts/MapContext'


// Custom hook to invalidate map size
function useMapEffect() {
  const map = useMap();
  useEffect(() => {
    map.invalidateSize();
  }, []);
}


export default function MapDisplay(props) {

  const {
    defaultCenter,
    tileLayer,

    lines,
    points,
    previewPoints,

    isWatermarkDisabled,
    isImageDownloadDisabled,
    isScrollWheelZoomDisabled,
  } = props

  const L = require("leaflet")

  useEffect(() => {
    // For some reason the following fixes the leaflet resources
    delete L.Icon.Default.prototype._getIconUrl
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png")
    })

    // Two finger dragging on mobile
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [])

  // Two finger dragging on mobile cont
  const [width, setWidth] = useState(window.innerWidth)
  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }
  const isMobile = width <= 768; // Two finger dragging on mobile

  const InvalidateSize = () => {
    useMapEffect();
    return null;
  };


  // Preview points & centering
  const [centerOverwrite, setCenterOverwrite] = useState([[], []])

  // This is getting preview points from JourneysForm via MyJourneys
  // Ideally will get rid of this reformat at some point
  const [internalPreviewPoints, setInternalPreviewPoints] = useState({ origin: undefined, destination: undefined })

  useEffect(() => {
    if (previewPoints.origin === undefined && previewPoints.destination === undefined)
      return

    let tempPreviewPoints = {
      origin: undefined,
      destination: undefined,
    }

    if (previewPoints.origin !== undefined && previewPoints.origin !== tempPreviewPoints.origin) {
      tempPreviewPoints.origin = {
        stationName: previewPoints.origin.name,
        position: [previewPoints.origin.latitude, previewPoints.origin.longitude]
      }
    }

    if (previewPoints.destination !== undefined && previewPoints.destination !== tempPreviewPoints.destination) {
      tempPreviewPoints.destination = {
        stationName: previewPoints.destination.name,
        position: [previewPoints.destination.latitude, previewPoints.destination.longitude]
      }
    }

    setInternalPreviewPoints({
      origin: tempPreviewPoints.origin,
      destination: tempPreviewPoints.destination
    })


    // Setting points for centering the map
    if (tempPreviewPoints.origin !== undefined && tempPreviewPoints.destination !== undefined) {
      setCenterOverwrite([tempPreviewPoints.origin.position, tempPreviewPoints.destination.position])
      return
    }

    if (tempPreviewPoints.origin !== undefined) {
      setCenterOverwrite([tempPreviewPoints.origin.position, []])
      return
    }

    if (tempPreviewPoints.destination !== undefined) {
      setCenterOverwrite([[], tempPreviewPoints.destination.position])
      return
    }
  }, [previewPoints])

  return (
    <>
        <MapContainer
          center={defaultCenter ? defaultCenter : [48.8566, 2.3522]}
          zoom={6}
          style={{ height: "100%" }} 
          dragging={isMobile ? false : true}
          tap={isMobile ? false : true}
          zoomControl={false}
          attributionControl={false}
          scrollWheelZoom={isScrollWheelZoomDisabled === undefined ? true : !isScrollWheelZoomDisabled}
        >
          <ZoomControl position="topright" />

          {!isWatermarkDisabled && (<MapWatermark />)}


          {!isImageDownloadDisabled && (<MapImageDownloadButton />)}
          <MapInitializer />

          <AttributionControl position="bottomright" prefix={false} />

          {/* Establishing provider */}
          { tileLayer.provider === 'google' && (
            <ReactLeafletGoogleLayer
              apiKey={process.env.REACT_APP_GOOGLEMAPS_API_KEY}
              type={tileLayer.attribute}
              attribution={tileLayer.attribution}
            />)}

          {tileLayer.provider !== 'google' && (
            <TileLayer
              attribution={tileLayer.attribution}
              url={tileLayer.url}
            />)}


          {/* Polylines */}

          {
            [...lines.existing, ...lines.preview].map((line) => {
              return (
                <Polyline
                  positions={line.positions}
                  pathOptions={line.pathOptions}
                />
              )
            })
          }

          {/* Points */}

          {/* Existing points */}
          {
            points.map((point) => {
              return (
                <StationMarker
                  point={point.properties}
                  variant={point.variant}
                />
              )
            })
          }

          {/* Preview points */}
          {
            internalPreviewPoints.origin && (
              <StationMarker
                point={internalPreviewPoints.origin}
                variant={'preview'}
              />
            )
          }
          {
            internalPreviewPoints.destination && (
              <StationMarker
                point={internalPreviewPoints.destination}
                variant={'preview'}
              />
            )
          }

          {/* Map functions */}
          <MapRecenterOnPoint centerOverwrite={centerOverwrite} />
          <InvalidateSize />

        </MapContainer>
    </>
  )
}
